import { render, staticRenderFns } from "./plan-details-mobile-nav.vue?vue&type=template&id=e490f09c"
import script from "./plan-details-mobile-nav.js?vue&type=script&lang=js&external"
export * from "./plan-details-mobile-nav.js?vue&type=script&lang=js&external"
import style0 from "./plan-details-mobile-nav.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports